// extracted by mini-css-extract-plugin
export default {"container":"Header_container__2IaoV","heading":"Header_heading__+J-s5","right":"Header_right__KuSsF"};